/**
 * User roles in the Fleet system
 */
export enum UserRole {
    Admin = 'Fleet.Admin',
    Support = 'Fleet.Support',
    Viewer = 'Fleet.Viewer'
}

/**
 * Role hierarchy - higher roles include permissions of lower roles
 */
export const roleHierarchy: Record<UserRole, UserRole[]> = {
    [UserRole.Admin]: [UserRole.Admin],
    [UserRole.Support]: [UserRole.Support, UserRole.Admin],
    [UserRole.Viewer]: [UserRole.Viewer, UserRole.Support, UserRole.Admin]
};

/**
 * Type for user permissions based on roles
 */
export interface UserPermissions {
    roles: UserRole[];
    hasRole: (role: UserRole) => boolean;
    hasAnyRole: (roles: UserRole[]) => boolean;
    canAccessAdminFeatures: boolean;
    canAccessSupportFeatures: boolean;
    canAccessViewerFeatures: boolean;
}

/**
 * Fallback UI types for ProtectedComponent
 */
export enum FallbackType {
    Button = 'button',
    Section = 'section',
    Page = 'page',
    Inline = 'inline',
}